import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import axios from "axios";

export default function ProtectedRoute({ children }) {
  const [authChecked, setAuthChecked] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const verifyAuth = async () => {
      try {
        const res = await axios.get(
          "https://mbmailer.mb-techs.com/mbmailer/auth/me",
          { withCredentials: true }
        );
        if (res.status === 200) {
          setIsLoggedIn(true);
        }
      } catch (err) {
        console.error("Auth check failed:", err.response?.data?.error || err.message);
        setIsLoggedIn(false);
      } finally {
        setAuthChecked(true);
      }
    };

    verifyAuth();
  }, []);

  if (!authChecked) {
    return <div className="p-4 text-center text-gray-600">Checking authentication...</div>;
  }

  return isLoggedIn ? children : <Navigate to="/login" replace />;
}
